import { randomIntBetween } from '@engineering11/utility'
import { ITraitDots } from '../../core/culture-index.model'
import { random } from 'lodash'

export function generateRandomTraitDots(): ITraitDots {
  return {
    A: randomIntBetween(0, 10),
    B: randomIntBetween(0, 10),
    C: randomIntBetween(0, 10),
    D: randomIntBetween(0, 10),
    L: randomIntBetween(0, 10),
    I: randomIntBetween(0, 10),
    EU: 41,
    Line: random(0, 10, true),
    EUText: '41',
  }
}

export const getCoreConfig = () => ({
  gridWidth: 13,
  gridHeight: 8,
  margin: { top: 3, right: 3, bottom: 3, left: 3 },
})
